<script setup>
import { computed, defineProps } from 'vue'

const props = defineProps({
  metrics: {
    type: Array,
    default: () => []
  },
  totalPrice: {
    type: String,
    default: '$0.00'
  },
  totalLabel: {
    type: String,
    default: 'Total Price'
  }
})

const visibleMetrics = computed(() => {
  return props.metrics.filter((metric) => metric.show !== false)
})
</script>

<template>
  <v-sheet class="light-blue-strip px-2 d-flex align-center flex-wrap">
    <div
      v-for="metric in visibleMetrics"
      :key="metric.label"
      class="metric-item mr-4 my-1"
    >
      <span class="font-weight-bold grey--text text--darken-1 mr-1">
        {{ metric.label }}:
      </span>
      <span>{{ metric.value }}</span>
    </div>

    <v-spacer />

    <div class="metric-price text-left my-1 d-flex flex-column justify-start">
      <div class="">
        <span class="font-weight-bold grey--text text--darken-1 mr-1">
          {{ totalLabel }}:
        </span>
        <span>{{ totalPrice }}</span>
      </div>
      <small class="grey--text font-italic total-sub">excl GST</small>
    </div>
  </v-sheet>
</template>

<style scoped>
.light-blue-strip {
  background: #e8f4fb !important;
}

.metric-item {
  white-space: nowrap;
}

.metric-price {
  min-width: 130px;
}

.total-sub {
  line-height: 1.1;
}
</style>
